/*
 *
 * SettingsLanguagePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 23-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SettingsLanguagePopup from './SettingsLanguagePopup'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'
import { doHideToast, doShowToast } from 'Store/actions/toast'
import { doLanguageChange } from 'Store/actions/language'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowToast, doHideToast }, dispatch),
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch),
  ...bindActionCreators({ doLanguageChange }, dispatch)
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SettingsLanguagePopup)
